import { nanoid } from 'nanoid'
import getStroke from 'perfect-freehand'

import {
  getCanvasCoord,
  getPathInitialData,
  getStrokeOptions,
  getSvgPathFromStroke,
  subtractCoordinates,
} from '../../utils/utils.js'

/**
 * 펜 이동 처리 함수
 * - 좌표 누적
 * - stroke 재계산
 * - path 정보 갱신
 */
export const handlePenMove = (e, state) => {
  const {
    clientCoord,
    scope,
    translate,
    paths,
    currentPath,
    currentPathId,
    selectedTool,
    isCapTrue,
    isSimulatePressure,
    thicknessVal,
    opacityVal,
    colorVal,
    previousPenPoint,
    // [동시편집]
    triggerAddPath,
    triggerUpdatePath,
  } = state

  // 현재 마우스 위치 변환
  const canvasCoord = getCanvasCoord(clientCoord, translate, scope)
  let delta = subtractCoordinates(canvasCoord, currentPath.current)

  const lastPath = currentPath.current
  lastPath.points = [...lastPath.points, { x: delta.x, y: delta.y, pressure: e.pressure }]

  // stroke 재계산
  const stroke = getStroke(
    lastPath.points,
    getStrokeOptions(thicknessVal[selectedTool], isSimulatePressure, isCapTrue)
  )
  const pathData = getSvgPathFromStroke(stroke)
  lastPath.d = pathData

  // 바운딩 정보 갱신
  lastPath.maxX = Math.max(lastPath.maxX, delta.x)
  lastPath.maxY = Math.max(lastPath.maxY, delta.y)
  lastPath.minX = Math.min(lastPath.minX, delta.x)
  lastPath.minY = Math.min(lastPath.minY, delta.y)

  lastPath.w = lastPath.maxX - lastPath.minX
  lastPath.h = lastPath.maxY - lastPath.minY
  lastPath.aspectRatio = lastPath.w === 0 ? 1 : lastPath.h / lastPath.w // NaN 방지

  triggerUpdatePath(currentPathId.current, lastPath, 'append', {
    x: delta.x,
    y: delta.y,
    pressure: e.pressure,
  })

  // 포인트의 수가 250개 이상이면 path를 분할하여 새로 생성
  if (lastPath.points.length >= 250) {
    const t = nanoid()
    currentPathId.current = t
    currentPath.current = getPathInitialData(
      'draw',
      Object.keys(paths).length,
      canvasCoord.x,
      canvasCoord.y,
      0,
      0,
      0,
      0,
      thicknessVal[selectedTool],
      opacityVal[selectedTool],
      colorVal[selectedTool],
      1,
      colorVal[selectedTool],
      e.pressure,
      false,
      1
    )

    previousPenPoint.current = canvasCoord
    paths[t] = currentPath.current

    triggerAddPath(t, currentPath.current)
  }
}
